export default {
    nav: {
        //之前沒寫, 就留空
        subject: ""
    }
}
